import { render } from "./TwitterBox.vue?vue&type=template&id=166877a2&scoped=true"
import script from "./TwitterBox.vue?vue&type=script&lang=js"
export * from "./TwitterBox.vue?vue&type=script&lang=js"

import "./TwitterBox.vue?vue&type=style&index=0&id=166877a2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src198257980/src/impact-vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166877a2"]])

export default __exports__